import { type ReactNode } from "react";
import { cn } from "@/utils";

/**
 * Kbd
 *
 * Renders a keyboard key hint in the monospace face — used in the sidebar,
 * search box and command affordances.
 */
export function Kbd({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <kbd
      className={cn(
        "inline-flex h-4 min-w-4 items-center justify-center rounded-sm border border-border",
        "bg-bg-elevated px-1 font-mono text-2xs text-text-tertiary",
        className,
      )}
    >
      {children}
    </kbd>
  );
}
